export default "a1775612639be0ebf16437d8cecdc1a5.png";